module.exports = __webpack_public_path__ + "static/media/banner04.2f6a2bdd.jpg";